module.exports = __webpack_public_path__ + "img/tit4.20aba87b.png";